import { useState } from "react";
import { toast } from "sonner";
import { useGlobalContext } from "../GlobalContext";

export default function useVolunteerBankDetails() {
  const { api, AdminId } = useGlobalContext();

  const [loading, setLoading] = useState(false);
  const [bankDetails, setBankDetails] = useState([]);

  const shouldShowLocalError = (data) => {
    return (
      data?.responseCode !== "00" &&
      data?.responseCode !== "02" &&
      data?.responseCode !== "03" &&
      data?.responseCode !== "98" &&
      data?.responseCode !== "401"
    );
  };

  const getVolunteerUserId = () => {
    try {
      const volunteerData = JSON.parse(
        sessionStorage.getItem("volunteerData") || "{}"
      );

      return String(
        volunteerData?.userId ||
          volunteerData?.userid ||
          volunteerData?.id ||
          AdminId ||
          ""
      );
    } catch (error) {
      return String(AdminId || "");
    }
  };

  /* ---------------- INSERT VOLUNTEER BANK DETAILS ---------------- */

  const insertVolunteerBankDetails = async (formData = {}) => {
    setLoading(true);

    try {
      const payload = {
        adminId: getVolunteerUserId(),
        volunteerId: String(formData.volunteerId || ""),
        email: String(formData.email || ""),
        phone: String(formData.phone || ""),
        bankName: String(formData.bankName || ""),
        bankHolderName: String(formData.bankHolderName || ""),
        accountNumber: String(formData.accountNumber || ""),
        ifscCode: String(formData.ifscCode || ""),
        aadharNumber: String(formData.aadharNumber || ""),
        panNumber: String(formData.panNumber || ""),
        primaryAccount: String(formData.primaryAccount || "Y"),
      };

      const response = await api.post(
        "/api/VolunteerUser/v1.0/insertVolunteerBankDetails",
        payload
      );

      if (response?.data?.responseCode === "00") {
        toast.success(
          response?.data?.responseMessage || "Bank details added successfully"
        );

        return true;
      }

      if (shouldShowLocalError(response?.data)) {
        toast.error(
          response?.data?.responseMessage || "Failed to add bank details"
        );
      }

      return false;
    } catch (error) {
      console.error("insertVolunteerBankDetails error:", error);
      toast.error("Something went wrong while adding bank details");
      return false;
    } finally {
      setLoading(false);
    }
  };

  /* ---------------- GET VOLUNTEER BANK DETAILS ---------------- */

  const getVolunteerBankDetails = async (volunteerId) => {
    setLoading(true);

    try {
      const response = await api.post(
        "/api/VolunteerUser/v1.0/getVolunteerBankDetails",
        {
          volunteerId: String(volunteerId || ""),
        }
      );

      if (response?.data?.responseCode === "00") {
        const list = Array.isArray(response?.data?.data)
          ? response.data.data
          : [];

        setBankDetails(list);

        return list;
      }

      if (shouldShowLocalError(response?.data)) {
        toast.error(
          response?.data?.responseMessage || "Failed to fetch bank details"
        );
      }

      setBankDetails([]);
      return [];
    } catch (error) {
      console.error("getVolunteerBankDetails error:", error);
      toast.error("Error fetching bank details");
      setBankDetails([]);
      return [];
    } finally {
      setLoading(false);
    }
  };

  /* ---------------- DELETE VOLUNTEER BANK DETAILS ---------------- */

  const deleteVolunteerBankDetails = async (bankId, volunteerId) => {
    setLoading(true);

    try {
      const response = await api.post(
        "/api/VolunteerUser/v1.0/deleteVolunteerBankDetails",
        {
          adminId: getVolunteerUserId(),
          bankId: String(bankId || ""),
        }
      );

      if (response?.data?.responseCode === "00") {
        toast.success(
          response?.data?.responseMessage || "Bank details deleted successfully"
        );

        if (volunteerId) {
          await getVolunteerBankDetails(volunteerId);
        }

        return true;
      }

      if (shouldShowLocalError(response?.data)) {
        toast.error(
          response?.data?.responseMessage || "Failed to delete bank details"
        );
      }

      return false;
    } catch (error) {
      console.error("deleteVolunteerBankDetails error:", error);
      toast.error("Something went wrong while deleting bank details");
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    insertVolunteerBankDetails,
    getVolunteerBankDetails,
    deleteVolunteerBankDetails,
    bankDetails,
    setBankDetails,
    loading,
    getVolunteerUserId,
  };
}